import { render } from "./changeLog.vue?vue&type=template&id=be64ead4&scoped=true&ts=true"
import script from "./changeLog.vue?vue&type=script&lang=ts"
export * from "./changeLog.vue?vue&type=script&lang=ts"

import "./changeLog.vue?vue&type=style&index=0&id=be64ead4&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be64ead4"]])

export default __exports__